export const NAV = [
  { id: "product", label: "Продукт" },
  { id: "effects", label: "ЛК автора" },
  { id: "effects-infringer", label: "ЛК нарушителя" },
  { id: "cases", label: "Наши кейсы" },
  { id: "faq", label: "FAQ" }
];

